import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';

import {API_GBG_CONFIG, API_TASK_STEP_GBG} from '../../../../config/urls';
import {GbgConfigDto} from '@dto/gbg-config-dto.model';
import {TaskStepUpdateDto} from '@dto/tasks/task-step-update.dto';
import {TaskStepGbgUpdateDto} from '@dto/tasks/task-step-gbg-update.dto';
import {UrlService} from '@shared/services/url.service';

@Injectable({
  providedIn: 'root'
})
export class GbgTaskService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getConfig(): Observable<GbgConfigDto> {
    return this.http.get<GbgConfigDto>(API_GBG_CONFIG);
  }

  public save(taskId: string, taskStepId: number, journeyId: string): Observable<TaskStepUpdateDto> {
    const endpointUrl = this.urlService.buildUrl(API_TASK_STEP_GBG, taskId, String(taskStepId));
    const gbgUpdateDto: TaskStepGbgUpdateDto = {
      journeyId: journeyId
    };
    return this.http.post<TaskStepUpdateDto>(endpointUrl, gbgUpdateDto);
  }
}
